module.exports = __webpack_public_path__ + "static/media/laszlo.123c6196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/laszlo.jpg
// module id = 379
// module chunks = 17